<template>
  <el-container class="height100">
    <el-header class="obpm-header-t">
      <admin_header />
    </el-header>
    <el-main  v-show="mode=='LIST'" class="superUser height100">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="obpm-header-nav">
        <el-breadcrumb-item :to="{ path: '/home' }">{{$t('location')}}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/superuser' }">{{$t('super_user_list')}}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-row class="obpm-fromContent-title obpm-enterpriseDomain-logo normalHeight">
          <el-col :span="12" class="normalLineH">{{$t('super_user_list')}}</el-col>
          <el-col :span="12" style="text-align:right" class=" normalLineH">
            <el-button type="primary" @click="onBack" size="small" plain>{{$t('back')}}</el-button>
            <el-button type="primary" @click="onCreateBtnClick" size="small" v-if="level!=3">{{$t('new')}}</el-button>
            <el-button @click="onDeleteBtnClick" size="small" type="danger" plain>{{$t('del')}}</el-button>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form :inline="true" :model="searchdata" class="demo-form-inline" size="mini"  @submit.native.prevent>
              <el-form-item :label="$t('name')">
                <el-input v-model="searchdata.name" :placeholder="$t('user_name')"  @keyup.enter.native="searchTableData"></el-input>
              </el-form-item>
              <el-form-item :label="$t('loginno')">
                <el-input v-model="searchdata.loginno" :placeholder="$t('loginno')"  @keyup.enter.native="searchTableData"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button @click="searchTableData" type="primary" plain>{{$t('query')}}</el-button>
                <el-button @click="resetSearchTableData">{{$t('reset')}}</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <!-- 用户列表 -->
        <el-table :data="tableData.datas" 
        stripe
          @row-click="onRowClick"
          ref="multipleTable"
          :row-key="handleReserve" 
          @selection-change="handleSelectionChange"
          header-cell-class-name="tableHeaderbg"
          class="Trpointer superUserList"
          size="small"
          >
          <el-table-column type="selection" width="55" ></el-table-column>
          <el-table-column prop="name" :label="$t('name')"></el-table-column>
          <el-table-column prop="loginno" :label="$t('loginno')"></el-table-column>
          <el-table-column prop="email" :label="$t('email')"></el-table-column>
          <el-table-column :label="$t('user_type')">
            <template slot-scope="scope">
              <span v-if="!isOpen">{{scope.row.superAdmin? $t('superAdmin') : ''}} | {{scope.row.developer? $t('develop') : ''}}</span>

              <span  v-if="isOpen">{{setType(scope.row.type)}}</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="searchTableData"
          :current-page.sync="searchdata.currpage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="searchdata.pagelines"
          layout="prev, pager, next, total, sizes"
          background
          :total="tableData.rowCount?tableData.rowCount:0"
        ></el-pagination>
    </el-main >
    <superUser_detail :detail="content"  @exit="onExit" v-show="mode=='DETAIL'" v-if="mode=='DETAIL'"/>
  </el-container>
</template>

<script>
import admin_header from "@/components/admin_header.vue";
import superUser_detail from "@/components/superUser_detail.vue";

export default {
  components: {
    admin_header,
    superUser_detail,
  },

  created() {
    this.level=this.$store.state.currentUser.level;
    if(this.$store.state.currentUser.isOpenSecurity){
      this.isOpen=true;
    }
    this.searchTableData();
  },

  data() {
    return {
      searchdata:{
        name:"",
        loginno:"",
        currpage:1,
        pagelines:10
      },
      tableData:{},
      multipleTable:[],
      content:{},
      mode:"LIST",
      multipleSelection:[],
      level:null,
      isOpen:false,//安全开关
    };
  },

  methods: {
    setType(type){
      let typeChina=this.$t('superAdmin');
      switch(type){
        case 'super':
          typeChina=this.$t('superAdmin');
        break;
        case 'admin':
          typeChina=this.$t('system_admin');
        break;
        case 'secret':
          typeChina=this.$t('secret');
        break;
        case 'examine':
          typeChina=this.$t('examine');
        break;
        case 'develop':
          typeChina=this.$t('develop');
        break;
      }
      return typeChina;
    },
    resetSearchTableData(){
      this.searchdata.name='';
      this.searchdata.loginno='';
      this.searchTableData();
    },
    onCreateBtnClick(){
      if(this.$store.state.currentUser.isOpenSecurity){
        //安全开关开启，默认issuperadmin和isdeveloper是false
        this.content={
          "status": 1,
          "superAdmin":false,
          "developer":false,
          "type":this.$store.state.currentUser.type
        }
      }else{
        this.content={
          "status": 1,
        }
      }
      this.mode="DETAIL";
    },
    onDeleteBtnClick(){
      if(this.multipleSelection.length>0){
        this.$api.deleteSuperUser({
          data:this.multipleSelection
        },{
          onSucess:resp =>{
            if(resp.data.errcode==0){
              this.$message({
                showClose: true,
                message: this.$t('msg_del_success'),
                type: "success"
              });
              this.searchTableData()
            }else{
              this.$message({
                showClose: true,
                message: resp.data.errmsg,
                type: "error"
              });
            }
          },
          onError:function(){

          }
        })
      }else{
        this.$message({
          showClose: true,
          message: this.$t('msg_select_superuser'),
          type: "error"
        });
      }
    },
    searchTableData(){
      this.$api.getSuperUserList(
         this.searchdata,
          {
            onSucess: resp => {
              if (resp.data.errcode == 0) {
                this.tableData=resp.data.data;
              } else {
                this.$message({
                  showClose: true,
                  message: resp.data.errmsg,
                  type: "error"
                });
              }
            },
            onError:(resp) => {
              this.$message({
                showClose: true,
                message: resp.data.errmsg,
                type: "false"
              });
            }
          }
        );
    },
    handleReserve(){
    },
    handleSizeChange(size){
      this.searchdata.pagelines=size;
      this.searchTableData();
    },
    handleSelectionChange(val){
      var arr = [];
       val.forEach((val) => {
        this.tableData.datas.forEach((v) => {
          if(val.id == v.id){
            arr.push(val.id)
          }
        })
      })   
      this.multipleSelection = arr;
    },
    onRowClick(row){
      if(row.domains)
      row.domains=row.domains[0];
      this.content=JSON.parse(JSON.stringify(row));
      this.mode="DETAIL";

    },
    onExit(){
      this.mode="LIST";
      this.searchTableData()
    },
    onBack(){
      this.$router.push({ name: 'home'})
    }
  }
};
</script>

<style>
</style>